import { JqueryHelperService } from './../../../jquery-helper.service';
import { Component, Input, OnInit, AfterContentInit, OnDestroy } from '@angular/core';
import { timeout } from 'q';
@Component({
  selector: 'ciu-product-images',
  templateUrl: './product-images.component.html',
  styleUrls: ['./product-images.component.css']
})
export class ProductImagesComponent implements OnInit, AfterContentInit, OnDestroy {

  constructor(private jQuery: JqueryHelperService) { }

  ngAfterContentInit(): void {
    setTimeout(() => {
      this.contentinit = true;
      this.jQuery.initZoom(this.isWindow);
    });
    this.jQuery.onMainImageLeave();
  }

  // selected = 0;
  @Input() productImages: any[] = [];
  @Input() isWindow: boolean;

  // zoomDisplay: number = 1;

  ngOnInit(): void {
    if (this.productImages && this.productImages.length > 0)
      this.selectedImage = this.productImages[0].imageUrl;

    // this.zoomDisplay = this.isWindow ? 11 : 1;

  }

  onMainImgLoad(event) {
    setTimeout(() => {
      this.jQuery.resetZoom(this.isWindow);
    });
  }

  returnimg(img) {
    this.jQuery.setImage(img);

    return img;
  }

  selectedImage: string = '';
  selectImage(image) {
    this.selectedImage = image;

    setTimeout(() => {
      this.jQuery.resetZoom(this.isWindow);
    });
  }

  offsetX;
  offsetY;
  contentinit: boolean = false;

  // returnZoomPos() {
  //   this.jQuery.zoomDiv();
  //   if (window.scrollY > 151) {
  //     return 7;
  //   }
  //   return this.zoomDisplay;
  // }

  // zoom(e: any) {
  //   let zoomer = e.currentTarget;
  //   e.offsetX ? this.offsetX = e.offsetX : this.offsetX = e.touches[0].pageX;
  //   e.offsetY ? this.offsetY = e.offsetY : this.offsetX = e.touches[0].pageX;
  //   const x = this.offsetX / zoomer.offsetWidth * 100;
  //   const y = this.offsetY / zoomer.offsetHeight * 100;
  //   zoomer.style.backgroundPosition = x + '% ' + y + '%';
  // }

  allowZoom(): boolean {
    if (window.innerWidth > 991 && this.contentinit) {
      return true;
    } else {
      return false
    }
  }

  ngOnDestroy(): void {
    this.jQuery.removeZoom();
  }

}



// WEBPACK FOOTER //
// C:/Users/majli/reposales365/sale365/src/app/container/product-details/product-images/product-images.component.ts